import * as React from "react"

const SvgButton = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 8.143a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a1 1 0 1 1-2 0v-3H5v8h5a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2z" />
    <path d="M12.034 12.68a.7.7 0 0 0-.012.392q.31 1.033.624 2.065c.46 1.517.92 3.034 1.362 4.556.17.582 1.015.588 1.198.01q.287-.903.588-1.803.562.563 1.122 1.129c.606.612 1.212 1.224 1.826 1.83a.99.99 0 0 0 1.4-.01l.565-.565a.99.99 0 0 0 .014-1.39c-.59-.605-1.192-1.199-1.795-1.792q-.564-.555-1.124-1.114.93-.33 1.861-.65c.563-.194.54-1.01-.032-1.173-1.52-.436-3.035-.894-4.55-1.352q-1.076-.326-2.153-.648a.7.7 0 0 0-.392.012.76.76 0 0 0-.318.184.76.76 0 0 0-.184.318Z" />
  </svg>
)
export default SvgButton
